import React from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { MonitoringService } from 'services/Monitoring/MonitoringService';
import App from './App';

library.add(fas, far);

const useTranslator = localStorage.getItem('useTranslator');
const appHtml = document.getElementsByTagName('html');

if (!useTranslator) {
  localStorage.setItem('useTranslator', 'false');
  appHtml[0].setAttribute('translate', 'no');
} else if (appHtml?.[0] && useTranslator === 'false') {
  appHtml[0].setAttribute('translate', 'no');
}

MonitoringService.init();

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);
